export default __webpack_public_path__ + "static/media/DinosaurSafari_02.daca5ace.png";